import { initialState } from "./state"

export default {
  setOrigin: (state, payload) => (state.origin = payload),
  setRules: (state, payload) => (state.rules = payload),
  updateLoading: (state, payload) => (state.loading = payload),
  setSummaryNote: (state, payload) => (state.summaryNote = payload),
  setIsEditingOfflineSale: (state, payload) =>
    (state.isEditingOfflineSale = payload),
  setIsEditing: (state, payload) => (state.isEditing = payload),
  setIsTransformingOfflineSale: (state, payload) =>
    (state.isTransformingOfflineSale = payload),
  setSaleToTransformId: (state, payload) => (state.saleToTransformId = payload),
  setAlreadySaved: (state, payload) => (state.alreadySaved = payload),
  setAlreadySynced: (state, payload) => (state.alreadySynced = payload),
  setSaleToEditId: (state, payload) => (state.saleToEditId = payload),
  addOfflineSale: (state, payload) => state.offlineSales.push(payload),
  setOfflineSales: (state, payload) => (state.offlineSales = payload),
  setIsSyncingOfflineSales: (state, payload) =>
    (state.isSyncingOfflineSales = payload),
  setSaleCode: (state, payload) => (state.saleCode = payload),
  setShowRGfield: (state, payload) => (state.showRGfield = payload),
  resetSale: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  }
}
